import { z } from 'zod';

import { makeFieldSchemaFromZod } from '../utils';

/**
 * Field schema for the KaapTenantPicker.
 * @public
 */

// Define the Tenant object schema that will be returned when returnFullObject is true
const TenantObjectSchema = z.object({
  id: z.string().describe('Tenant ID (unique identifier)'),
  name: z.string().describe('Tenant name'),
  clusterId: z.string().describe('Cluster ID the tenant belongs to'),
  clusterSubscription: z
    .string()
    .describe('Cluster subscription the tenant belongs to'),
  clusterName: z.string().describe('Cluster name the tenant belongs to'),
  ownerId: z.string().describe('Owner ID of the tenant'),
});

export const KaapTenantPickerFieldSchema = makeFieldSchemaFromZod(
  z.object(TenantObjectSchema.shape),
);

/**
 * UI options for the KaapTenantPicker.
 * @public
 */

export type KaapTenantPickerUiOptions = {};

/**
 * Props for the KaapTenantPicker.
 * @public
 */

export type KaapTenantPickerProps = typeof KaapTenantPickerFieldSchema.type;

/**
 * Schema for the KaapTenantPicker.
 * @public
 */

export const KaapTenantPickerSchema = KaapTenantPickerFieldSchema.schema;
